export const RobotoFont = {
  lightFamily: 'Roboto Light',
  regularFamily: 'Roboto',
  semiBoldFamily: 'Roboto Medium',
  boldFamily: 'Roboto Bold',
  lightWeight: 300,
  regularWeight: 500,
  boldWeight: 600,
};

export const RalewayFont = {
  lightFamily: 'Raleway Light',
  regularFamily: 'Raleway',
  semiBoldFamily: 'Raleway Medium',
  boldFamily: 'Raleway Bold',
  lightWeight: 300,
  regularWeight: 500,
  boldWeight: 600,
};

export default {
  RobotoFont,
  RalewayFont,
};



// WEBPACK FOOTER //
// ./src/constants/fonts.js